import { Fragment, useEffect, useRef } from 'react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select/dist/declarations/src/Select';
import { CustomFilter } from '../../../components/CustomFilter';
import ReactSelect from 'react-select';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import { UserGroupRelationModel } from '../../auth/models/UserGroupRelationModel';
import { EntityFiltersModel } from '../../../models/EntityFiltersModel';
import { FilterBadge } from '../../../models/FilterBadge';
import { CustomBadgeFilter } from '../../../components/CustomBadgeFilter';
import { FilterCascadeEntitySelections } from '../../../components/FilterCascadeEntitySelection';

interface PropsFilter {
  queryParams: any;
  setQueryParams: any;
}
const activeOptions = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' },
];

export function InventoriesFilter({
  setQueryParams,
  queryParams,
}: PropsFilter) {
  const userGroupRelations = useSelector<RootState, UserGroupRelationModel>(
    ({ auth }: any) => auth.userGroupRelation,
    shallowEqual
  );
  // Filter States
  const [isActive, setIsActive] = useState<boolean | null>();
  const isActiveRef = useRef<null | Select>(null);
  const [from, setFrom] = useState<string | null>();
  const fromRef = useRef<any>(null);

  const [to, setTo] = useState<string | null>();
  const toRef = useRef<any>(null);

  const [reset, setReset] = useState<boolean>(false);
  const [quantityDays, setQuantityDays] = useState<number | null>();
  const quantityDaysRef = useRef<any>(null);

  //Entity
  const [entityFilters, setEntityFilters] = useState<EntityFiltersModel>({
    accountId: null,
    clientId: null,
    franchiseId: null,
    locationId: null,
  });

  const handleIsActive = (params: any) => {
    if (params) {
      setIsActive(params.value);
    } else {
      setIsActive(undefined);
    }
  };

  const handleFrom = (e: any) => {
    if (e.target.value) {
      setFrom(e.target.value);
    } else {
      setFrom(undefined);
    }
  };

  const handleTo = (e: any) => {
    if (e.target.value) {
      setTo(e.target.value);
    } else {
      setTo(undefined);
    }
  };

  const handleQuantityDays = (e: any) => {
    if (e.target.value) {
      setQuantityDays(e.target.value);
    } else {
      setQuantityDays(undefined);
    }
  };

  const resetFilters = () => {
    // Update QueryParams: Review if
    const newQueryParams = { ...queryParams };
    isActiveRef.current?.clearValue();
    newQueryParams.pageNumber = 1;
    newQueryParams.from = undefined;
    newQueryParams.to = undefined;
    newQueryParams.quantityDays = 90;
    newQueryParams.active = true;
    newQueryParams.accountId = userGroupRelations.accountId
      ? userGroupRelations.accountId
      : undefined;
    newQueryParams.clientId = userGroupRelations.clientId
      ? userGroupRelations.clientId
      : undefined;
    newQueryParams.franchiseId = userGroupRelations.franchiseId
      ? userGroupRelations.franchiseId
      : undefined;
    newQueryParams.locationId = userGroupRelations.locationId
      ? userGroupRelations.locationId
      : undefined;
    setTo(undefined);
    setFrom(undefined);
    setQuantityDays(90);
    setQueryParams(newQueryParams);
    setReset(true);
  };

  const applyFilter = () => {
    const newQueryParams = { ...queryParams };
    newQueryParams.from = from;
    newQueryParams.to = to;
    newQueryParams.pageNumber = 1;
    newQueryParams.active = isActive;
    newQueryParams.accountId = entityFilters?.accountId;
    newQueryParams.clientId = entityFilters?.clientId;
    newQueryParams.franchiseId = entityFilters?.franchiseId;
    newQueryParams.locationId = entityFilters?.locationId;
    newQueryParams.quantityDays = quantityDays;
    setQueryParams(newQueryParams);
  };
  const showEntitiesFilter = !userGroupRelations.locationId;

  /** START Filter Badges */
  const [filterBadges, setFilteBadges] = useState<FilterBadge[]>([]);
  const [entityFilterBadges, setEntityFilteBadges] = useState<FilterBadge[]>(
    []
  );
  // Get initial values from the url
  useEffect(() => {
    let clearFilters = [];

    if (!!queryParams.active || queryParams.active === false) {
      updateBadge(
        'active',
        queryParams.active === true
          ? 'Active'
          : queryParams.active === false
          ? 'Inactive'
          : '',
        isActiveRef
      );
      setIsActive(queryParams.active);
    } else {
      clearFilters.push('active');
    }

    if (queryParams.from !== null && queryParams.from !== undefined) {
      setFrom(queryParams.from);
      updateBadge('from', 'Lvl. from: ' + queryParams.from, fromRef);
    } else {
      clearFilters.push('from');
    }
    if (queryParams.to !== null && queryParams.to !== undefined) {
      setTo(queryParams.to);
      updateBadge('to', 'Lvl. to: ' + queryParams.to, toRef);
    } else {
      clearFilters.push('to');
    }
    if (
      queryParams.quantityDays !== null &&
      queryParams.quantityDays !== undefined
    ) {
      setQuantityDays(queryParams.quantityDays);
      updateBadge(
        'quantityDays',
        queryParams.quantityDays + ' Days',
        quantityDaysRef
      );
    } else {
      clearFilters.push('quantityDays');
    }
    if (entityFilterBadges.length > 0) {
      entityFilterBadges.forEach((item: FilterBadge) => {
        updateBadge(item.key, item.value, item.ref);
      });
    }

    if (!queryParams.accountId) clearFilters.push('accountId');
    if (!queryParams.clientId) clearFilters.push('clientId');
    if (!queryParams.franchiseId) clearFilters.push('franchiseId');
    if (!queryParams.locationId) clearFilters.push('locationId');

    if (clearFilters.length > 0) {
      clearMultipleFilter(clearFilters);
    }

    // Get initial values from the url
    const newQueryParams = {
      ...entityFilters,
      accountId: queryParams.accountId ? queryParams.accountId : undefined,
      clientId: queryParams.clientId ? queryParams.clientId : undefined,
      franchiseId: queryParams.franchiseId
        ? queryParams.franchiseId
        : undefined,
      locationId: queryParams.locationId ? queryParams.locationId : undefined,
    };
    setEntityFilters(newQueryParams);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams]);

  const clearMultipleFilter = (filters: Array<string>) => {
    let badges = filterBadges;
    filters.forEach((element) => {
      badges = badges.filter((item: FilterBadge) => item.key !== element);
    });
    setFilteBadges(badges);
  };
  const clearFilter = (ref: any, keyParam: string) => {
    if (
      keyParam === 'accountId' ||
      keyParam === 'clientId' ||
      keyParam === 'franchiseId'
    ) {
      clearMultipleFilter([
        'accountId',
        'clientId',
        'franchiseId',
        'locationId',
      ]);
      setEntityFilteBadges([]);
      let params = { ...queryParams };
      params['accountId'] = userGroupRelations.accountId
        ? userGroupRelations.accountId
        : undefined;
      params['clientId'] = userGroupRelations.clientId
        ? userGroupRelations.clientId
        : undefined;
      params['franchiseId'] = userGroupRelations.franchiseId
        ? userGroupRelations.franchiseId
        : undefined;
      params['locationId'] = userGroupRelations.locationId
        ? userGroupRelations.locationId
        : undefined;
      setQueryParams(params);

      filterBadges
        .find((element) => element.key === 'accountId')
        ?.ref.current?.clearValue();
      filterBadges
        .find((element) => element.key === 'clientId')
        ?.ref.current?.clearValue();
      filterBadges
        .find((element) => element.key === 'franchiseId')
        ?.ref.current?.clearValue();
      filterBadges
        .find((element) => element.key === 'locationId')
        ?.ref.current?.clearValue();
    } else if (ref) {
      if (ref.current?.type === 'number') {
        ref.current.value = null;
      } else {
        ref.current?.clearValue();
      }
      let params = { ...queryParams };
      params[keyParam] = undefined;
      setQueryParams(params);
    }

    setFilteBadges(
      filterBadges.filter((item: FilterBadge) => item.key !== keyParam)
    );
  };
  const updateBadge = (key: string, value: string, ref: any) => {
    let badges = filterBadges;
    const finded = badges?.find((item: FilterBadge) => item.key === key);
    if (finded && finded !== undefined) {
      badges.splice(badges.indexOf(finded), 1, {
        key: key,
        value: value,
        ref: ref,
      });
    } else {
      badges.push({
        key: key,
        value: value,
        ref: ref,
      });
    }
    setFilteBadges(badges);
  };

  /** END Filter Badges */

  return (
    <>
      {filterBadges?.map((item: FilterBadge) => {
        if (item.value && item.value !== '')
          return (
            <CustomBadgeFilter
              text={item.value}
              key={item.key}
              badgeKey={item.key}
              clearFilter={() => {
                if (item.ref) clearFilter(item.ref, item.key);
              }}
            ></CustomBadgeFilter>
          );
        else return <></>;
      })}

      <CustomFilter
        applyFilters={applyFilter}
        resetFilters={resetFilters}
        scroll={false}
        size={showEntitiesFilter ? 'lg' : 'md'}
      >
        <Fragment>
          <div className='row'>
            <div className='col-md-6'>
              <FilterCascadeEntitySelections
                setReset={setReset}
                reset={reset}
                entityFilters={entityFilters}
                setEntityFilters={setEntityFilters}
                setEntityListBadge={setEntityFilteBadges}
                entityFilterBadges={entityFilterBadges}
              />
            </div>
            <div className={showEntitiesFilter ? 'col-md-6' : 'col-md-12'}>
              <div onClick={(e) => e.stopPropagation()}>
                <label className='form-label fw-bold my-2'>Active</label>
                <ReactSelect
                  placeholder={<FormattedMessage id='COMMON.ALL' />}
                  isClearable
                  name='isActive'
                  id='isActive'
                  onChange={handleIsActive}
                  options={activeOptions}
                  value={
                    activeOptions
                      ? activeOptions.filter(
                          (x: any) => x.value === isActive
                        )[0]
                      : null
                  }
                  ref={isActiveRef}
                  defaultValue={activeOptions[0]}
                />
                <label className='form-label fw-bold my-2'>
                  Current Level From
                </label>
                <input
                  ref={fromRef}
                  autoComplete='none'
                  type='number'
                  className='form-control form-control-sm form-control-solid'
                  defaultValue={from ? from : ''}
                  onChange={(e) => handleFrom(e)}
                />
                <label className='form-label fw-bold my-2'>
                  Current Level To
                </label>
                <input
                  ref={toRef}
                  autoComplete='none'
                  type='number'
                  className='form-control form-control-sm form-control-solid'
                  defaultValue={to ? to : ''}
                  onChange={(e) => handleTo(e)}
                />
                <label className='form-label fw-bold my-2'>Quantity Days</label>
                <input
                  ref={quantityDaysRef}
                  autoComplete='none'
                  type='number'
                  className='form-control form-control-sm form-control-solid'
                  defaultValue={quantityDays ? quantityDays : 90}
                  onChange={(e) => handleQuantityDays(e)}
                />
              </div>
            </div>
          </div>
        </Fragment>
      </CustomFilter>
    </>
  );
}
